/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByCustomAggregateKind = (typeof GroupByCustomAggregateKind)[keyof typeof GroupByCustomAggregateKind];

export const GroupByCustomAggregateKind = {
  custom_aggregate: 'custom_aggregate',
} as const;
